import {
  MULTI_SELECT_ALL_TEXT,
  RESULT_TYPES,
  RESULT_TYPES_STRING,
  RESULT_TYPES_MODULE,
  EXPORT_RESULT_MODULE,
  RESULT_SCREEN_STRING,
} from "src/constants/constants";

export const MULTI_SELECT_ALL_ID = "0";

export const SELECT_ALL = [
  {
    text: MULTI_SELECT_ALL_TEXT,
    id: MULTI_SELECT_ALL_ID,
  },
];

export const PERIODSTYPE = {
  YEAR: "year",
  QUARTER: "quarter",
  MONTH: "month",
};

export const getRuleResultMasterKeyByPathname = (pathname) => {
  switch (pathname) {
    case RESULT_TYPES.CREDITS:
      return "credit_rule_results_key";
    case RESULT_TYPES.MEASUREMENTS:
      return "measure_rule_results_key";
    case RESULT_TYPES.INCENTIVES:
      return "incentive_rule_results_key";
    case RESULT_TYPES.PAYMENTS:
      return "payment_rule_results_key";
    default:
      return "";
  }
};

export const fetchRuleResultValue = (pathname) => {
  let ruleResultValue = "";
  switch (pathname) {
    case RESULT_TYPES.CREDITS:
      ruleResultValue = RESULT_TYPES_STRING.CREDITS;
      break;
    case RESULT_TYPES.MEASUREMENTS:
      ruleResultValue = RESULT_TYPES_STRING.MEASUREMENTS;
      break;
    case RESULT_TYPES.INCENTIVES:
      ruleResultValue = RESULT_TYPES_STRING.INCENTIVES;
      break;
    case RESULT_TYPES.PAYMENTS:
      ruleResultValue = RESULT_TYPES_STRING.PAYMENTS;
      break;
    default:
      break;
  }
  return ruleResultValue;
};

export const getModule = (module) => {
  let string = "";
  switch (module) {
    case RESULT_TYPES.CREDITS:
      string = RESULT_TYPES_MODULE.CREDITS;
      break;
    case RESULT_TYPES.MEASUREMENTS:
      string = RESULT_TYPES_MODULE.MEASUREMENTS;
      break;
    case RESULT_TYPES.INCENTIVES:
      string = RESULT_TYPES_MODULE.INCENTIVES;
      break;
    case RESULT_TYPES.PAYMENTS:
      string = RESULT_TYPES_MODULE.PAYMENTS;
      break;
    default:
      break;
  }
  return string;
};

export const getCommonObjects = (arr1, arr2) => {
  if (arr2) {
    return arr1.filter((obj1) => arr2.some((obj2) => obj1?.id === obj2?.id && obj1?.name === obj2?.name));
  }
  return [];
};

export const getResultType = (pathname) => {
  switch (pathname) {
    case RESULT_TYPES.CREDITS:
      return "credit";
    case RESULT_TYPES.MEASUREMENTS:
      return "measure";
    case RESULT_TYPES.INCENTIVES:
      return "incentive";
    case RESULT_TYPES.PAYMENTS:
      return "payment";
    default:
      return "";
  }
};

export const extractIds = (data = []) =>
  data
    .filter((item) => item.id !== MULTI_SELECT_ALL_ID)
    .map((item) => item.id.toString())
    .join(",");

export const fetchExportProcName = (path) => {
  let string = "";
  switch (path) {
    case RESULT_TYPES.CREDITS:
      string = EXPORT_RESULT_MODULE.CREDITS;
      break;
    case RESULT_TYPES.MEASUREMENTS:
      string = EXPORT_RESULT_MODULE.MEASUREMENTS;
      break;
    case RESULT_TYPES.INCENTIVES:
      string = EXPORT_RESULT_MODULE.INCENTIVES;
      break;
    case RESULT_TYPES.PAYMENTS:
      string = EXPORT_RESULT_MODULE.PAYMENTS;
      break;
    default:
      break;
  }
  return string;
};

export const fetchScreenName = (path) => {
  let ruleResultValue = "";
  switch (path) {
    case RESULT_TYPES.CREDITS:
      ruleResultValue = RESULT_SCREEN_STRING.CREDITS;
      break;
    case RESULT_TYPES.MEASUREMENTS:
      ruleResultValue = RESULT_SCREEN_STRING.MEASUREMENTS;
      break;
    case RESULT_TYPES.INCENTIVES:
      ruleResultValue = RESULT_SCREEN_STRING.INCENTIVES;
      break;
    case RESULT_TYPES.PAYMENTS:
      ruleResultValue = RESULT_SCREEN_STRING.PAYMENTS;
      break;
    default:
      break;
  }
  return ruleResultValue;
};
